import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login'
import PasswordRegistration from '@/views/PasswordRegistration'
import SubsidiaryLogin from '@/views/SubsidiaryLogin'
import NotFound from '@/views/Error/404'
import Home from '@/views/Home'
import Test from '@/views/Sys/PCindex'
import store from '@/store'
import api from '@/http/api';
import Cookies from "js-cookie";
import VueLocalForage from "vue-localforage";
import { getIFramePath, getIFrameUrl } from '@/utils/iframe'
import XyjVueLoader from "../../static/XyjVueLoader.js";
const _import = require('./_import_' + process.env.NODE_ENV);
const tmpVue = new Vue();
Vue.use(VueLocalForage);
Vue.use(Router)

const router = new Router({
	mode: 'hash',
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home,
      redirect: '/Sys/PCindex',
      children: [{
        path: '/Sys/PCindex',
        name: '首页',
        component: Test
      }]
    },
    {
      path: '/Login',
      name: '登录',
      component: Login
    },
    {
      path: '/CLogin',
      name: '子公司登录',
      component: SubsidiaryLogin
    },
    {
			path: '/pwdRegister',
			name: '密码注册',
			component: PasswordRegistration
		},
    {
      path: '/404',
      name: 'notFound',
      component: NotFound
    },
  ],
})

/**
* wwd 2020年8月18日11:41:59
* storeRoute // 存储的数据
* routerData // 定义的变量
* 描述： 防止刷新页面的时候 导致页面空白
*/
function storeRouter() {
  if (localStorage.getItem("storeRoute")) {
    var routerData = JSON.parse(localStorage.getItem("storeRoute"));
    if(window.location.hash.substr(2) == routerData.path){
      // 地址栏地址和缓存一致
      // for (let i = 0;i < routerData.length;i++) {
        if (routerData.meta.parentName) {
          // 本地组件
          // componentCode = tmpVue.$getItem(routerData[i].name);
        } else {
          tmpVue.$getItem(routerData.name, function(el, value) {
            if (value) {
              var sourceCodeObj = JSON.parse(value);
              const tmpComponent = XyjVueLoader(sourceCodeObj.componentCode);
              const routeMeta = routerData
              tmpComponent().then((comp) => {
                const path = {
                  path: sourceCodeObj.componentPath,
                  name: sourceCodeObj.componentPath,
                  component: comp,
                  meta:routeMeta.meta
                };
                let routeArr = router.options.routes[0].children;
                for (var i = 0;i < routeArr.length;i++) {
                  if (routeArr[i].path.replace("/", "") == sourceCodeObj.componentPath.replace("/", "")) {
                    i = routeArr.length;
                  } else if (i == routeArr.length - 1) {
                    router.options.routes[0].children.push(path);
                    selfaddRoutes(router.options.routes);
                    store.commit('updateMainTabs', [{
                      icon:path.meta.icon,
                      name:path.name,
                      parentName:path.meta.parentName,
                      path:path.path,
                      title:path.meta.name
                    }])
                    store.commit('updateMainTabsActiveName','/'+path.path)
                    // router.addRoutes(router.options.routes);
                  }
                }
              });
            }
          });
        }
      // }
    }else{
      
    }
  }
}

router.beforeEach((to, from, next) => {
  // 登录界面登录成功之后，会把用户信息保存在会话
  // 存在时间为会话生命周期，页面关闭即失效。
  let userName = sessionStorage.getItem('user')
  // let loginURL = window.location.pathname == '/Login' ? '/Login': window.location.pathname == '/SubsidiaryLogin' ? '/SubsidiaryLogin' : '/Login';
  let loginURL = window.location.href.split('#')[1] == '/Login' ? '/Login'
: window.location.href.split('#')[1] == '/CLogin' ? '/CLogin' : '/Login';
  if(sessionStorage.getItem('branchCode') && sessionStorage.getItem('branchCode')!=='1') loginURL = '/CLogin';
  if (to.path === loginURL) {
    // 如果是访问登录界面，如果用户会话信息存在，代表已登录过，跳转到主页
    if(userName) {
      next({ path: '/Sys/PCindex' })
    } else {
      next()
    }
  } else {
    if (!userName) {
      // 如果访问非登录界面，且户会话信息不存在，代表未登录，则跳转到登录界面
      next({ path: loginURL })
    } else {
      // 加载动态菜单和路由
      addDynamicMenuAndRoutes(userName, to, from);
      next();

      /**
       *宋建国：2019/11/25 15:14
       *描述：消息服务器连接
       *版本：1.0
       */
      if(!window.$mqtt.getClient()){
        window.$mqtt.xyjConnect();
      }else{
        if(!window.$mqtt.isConnected()){
          window.$mqtt.xyjConnect();
        }else if(window.$mqtt.getUserName() !== userName){
        	window.$mqtt.disconnect();
        	window.$mqtt.xyjConnect();
        }
      }
    }
  }

})

// 解决重复点击菜单控制台报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this,location).catch(err => err)
}

const oldAddRoutes = router.__proto__.addRoutes;
router.__proto__.addRoutes = function (routes) {
  router.matcher = new Router({mode: 'hash'}).matcher;
  oldAddRoutes.call(this,routes);
}

/**
 *宋建国：2020/2/20 16:36
 *描述：重新包装路由push方法,如果通过$router.push({name:组件名称})的方式路由跳转，函数自动到远程加载组件
 *版本：1.0
 */
const routerPush = router.__proto__.push;
router.__proto__.push = function (location) {
  if(this.app.$tu.isClass(location) === "Object"){ //通过对象跳转
    if(!this.app.$tu.isBlank(location.path)) { //通过路径跳转
      if(!this.app.$tu.isBlank(this.app.$store.state.app.drapRoutePath)) { //在拖拽页面
        if (location.path.charAt(0) !== "/") {
          location.path = '/' + this.app.$store.state.app.drapRoutePath + '/'+ location.path;
        }else {
          location.path = '/' + this.app.$store.state.app.drapRoutePath + location.path;
        }
      }
      routerPush.call(this,location);
      return;
    }
    if(!this.app.$tu.isBlank(location.name)) { //通过路由名称加载远程组件，并增加到路由表
      let then = this;
      this.app.$api.component.XyjPcRoutesPush(this.app, {componentName:location.name,loadPath:location.loadPath,chinesename:location.chinesename,processKey:location.processKey,tabs:location.tabs}).then((res) => {
        routerPush.call(then,location);
      }).catch((error) => {

      });
    }else{
      this.app.$message.error("路由路径与路由名称都没出入,无法跳转");
    }
  }else if(this.app.$tu.isClass(location) === 'String'){ //push通过字符串路径跳转
    if(location === '/' ){
      routerPush.call(this,location);
      return;
    }
    if(this.app.$tu.isBlank(location)){
      routerPush.call(this,location);
      return;
    }
   /* //通过路径跳转
    if(!this.app.$tu.isBlank(this.app.$store.state.app.drapRoutePath)) { //在拖拽页面
      if (location.charAt(0) !== "/") {
        location = '/' + this.app.$store.state.app.drapRoutePath + '/'+ location;
      }else{
        location = '/' + this.app.$store.state.app.drapRoutePath + location;
      }
    }*/
    routerPush.call(this,location);
    return;
  }
}

/**
 *宋建国：2020/2/20 16:36
 *描述：重新包装路由push方法,如果通过$router.push({name:组件名称})的方式路由跳转，函数自动到远程加载组件
 *版本：1.0
 */
const routerReplace = router.__proto__.replace;
router.__proto__.replace = function (location) {
  if(this.app.$tu.isClass(location) === "Object"){ //通过对象跳转
    if(!this.app.$tu.isBlank(location.path)) { //通过路径跳转
      if(!this.app.$tu.isBlank(this.app.$store.state.app.drapRoutePath)) { //在拖拽页面
        if (location.path.charAt(0) !== "/") {
          location.path = '/' + this.app.$store.state.app.drapRoutePath + '/'+ location.path;
        }else {
          location.path = '/' + this.app.$store.state.app.drapRoutePath + location.path;
        }
      }
      routerReplace.call(this,location);
      return;
    }
    if(!this.app.$tu.isBlank(location.name)) { //通过路由名称加载远程组件，并增加到路由表
      let then = this;
      this.app.$api.component.XyjPcRoutesPush(this.app, {componentName:location.name,loadPath:location.loadPath,chinesename:location.chinesename,processKey:location.processKey,tabs:location.tabs}).then((res) => {
        routerReplace.call(then,location);
      }).catch((error) => {

      });
    }else{
      this.app.$message.error("路由路径与路由名称都没出入,无法跳转");
    }
  }else if(this.app.$tu.isClass(location) === 'String'){ //push通过字符串路径跳转
    if(location === '/' ){
      routerReplace.call(this,location);
      return;
    }
    if(this.app.$tu.isBlank(location)){
      routerReplace.call(this,location);
      return;
    }
//  //通过路径跳转
//  if(!this.app.$tu.isBlank(this.app.$store.state.app.drapRoutePath)) { //在拖拽页面
//    if (location.charAt(0) !== "/") {
//      location = '/' + this.app.$store.state.app.drapRoutePath + '/'+ location;
//    }else{
//      location = '/' + this.app.$store.state.app.drapRoutePath + location;
//    }
//  }
    routerReplace.call(this,location);
    return;
  }
}

function selfaddRoutes (params){
  router.matcher = new Router().matcher;
  router.addRoutes(params)
}

/**
 * 加载动态菜单和路由
 */
function addDynamicMenuAndRoutes(userName, to, from) {
  // store.commit('updateKey', Math.ceil(Math.random()*10));
  // 处理IFrame嵌套页面
  handleIFrameUrl(to.path);
  if(store.state.app.menuRouteLoaded) {
    console.log('动态菜单和路由已经存在.')
    return
  }
  store.commit('setDrapRoutePath', "");
  let axiosurl = sessionStorage.getItem('branchCode')!=='1' ? api.menu.findBranchMenu : api.menu.findNavTree
  axiosurl({'userName':userName}).then(res => {
    // 添加动态路由
    let dynamicRoutes = addDynamicRoutes(res.data);
    router.options.routes[0].children.length = 0;
    router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
    selfaddRoutes(router.options.routes)
    // router.push({path:'/Sys/PCindex',name:'首页'})
    storeRouter();
    // 保存加载状态
    store.commit('menuRouteLoaded', true)
    // 保存菜单树
    store.commit('setNavTree', res.data)
  }).then(res => {
    sessionStorage.getItem('branchCode')!=='1'?
    api.user.findBranchPermissions({
        'name':userName,
      }).then(res => {
        // 保存用户权限标识集合
        store.commit('setPerms', res.data)
      })
      : api.user.findPermissions({
        'name':userName,
      }).then(res => {
        // 保存用户权限标识集合
        store.commit('setPerms', res.data)
      });
    api.menu.findAllComponent().then((res)=>{
      if(res.code == 200){
        store.commit('setRemoteComponentVersion',res.data);
      }
    }).catch((error)=>{
      console.error(error);
    })

  }).catch(err => {
    console.error(err);
  })
}

/**
 * 处理IFrame嵌套页面
 */
function handleIFrameUrl(path) {
  // 嵌套页面，保存iframeUrl到store，供IFrame组件读取展示
  let url = path
  let length = store.state.iframe.iframeUrls.length
  for(let i=0; i<length; i++) {
    let iframe = store.state.iframe.iframeUrls[i]
    if(path != null && path.endsWith(iframe.path)) {
      url = iframe.url
      store.commit('setIFrameUrl', url)
      break
    }
  }
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function addDynamicRoutes (menuList = [], routes = []) {
  var temp = []
  let keepalive = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      for(var j = 0;j<menuList[i].children.length;j++){
        menuList[i].children[j].parentName = menuList[i].name;
      }
      temp = temp.concat(menuList[i].children)
    } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
      //删除开头/
      menuList[i].url = menuList[i].url.replace(/^\//, '')
      // 获取所有组件的name值
      keepalive.push(menuList[i].url.split('/')[menuList[i].url.split('/').length-1]);
      // 创建路由配置
      var route = {
        path: menuList[i].url,
        component: null,
        name: menuList[i].name,
        meta: {
          name: menuList[i].name,
          icon: menuList[i].icon,
          parentName:menuList[i].parentName,
          processKey:menuList[i].cid,
          tabs:menuList[i].label
          // dataAuthority:menuList[i].dataAuthority
        }
      }
      let path = getIFramePath(menuList[i].url)
      if (path) {
        // 如果是嵌套页面, 通过iframe展示
        route['path'] = path
        route['component'] = resolve => require([`@/views/IFrame/IFrame`], resolve)
        // 存储嵌套页面路由路径和访问URL
        let url = getIFrameUrl(menuList[i].url)
        let iFrameUrl = {'path': path, 'url': url}
        store.commit('addIFrameUrl', iFrameUrl)
        routes.push(route)
      } else {
      	if(menuList[i].isDrag != 1){ 
	        try {
	          // 根据菜单URL动态加载vue组件，这里要求vue组件须按照url路径存储
	          // 如url="sys/user"，则组件路径应是"@/views/sys/user.vue",否则组件加载不到
	          let array = menuList[i].url.split('/')
	          let tmpurl = "";
	          for (let z = 0; z < array.length; z++) {
              tmpurl = tmpurl + array[z].substring(0, 1).toUpperCase() + array[z].substring(1) + '/'
	          }
            tmpurl = tmpurl.substring(0, tmpurl.length - 1)
	          // route['component'] = resolve => require([`@/views/${url}`], resolve)
            route['component'] = _import(`${tmpurl}`);
	          routes.push(route);
	        } catch (e) {
	        }
        }
      }
    }
  }
  // 存储需要缓存的组件
  store.commit('updateKey', keepalive);
  if (temp.length >= 1) {
    addDynamicRoutes(temp, routes)
  } else {
    console.log('动态路由加载完成.')
  }
  return routes;
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js